// extracted by css-extract-rspack-plugin
var _1 = "NotesArea-m_addNotesLabel-HmOxqgLf";
var _2 = "NotesArea-m_editIcon-BHlvRjJI";
var _3 = "NotesArea-m_error-nX941WfJ";
var _4 = "NotesArea-m_minimal-Sf3FqNkq";
var _5 = "NotesArea-m_noNotesYet-aiG2iNi0";
var _6 = "NotesArea-m_notesLabel-Kfce4lYw";
var _7 = "NotesArea-m_openNotesEditor-NOec1BKM";
export { _1 as "addNotesLabel", _2 as "editIcon", _3 as "error", _4 as "minimal", _5 as "noNotesYet", _6 as "notesLabel", _7 as "openNotesEditor" }
